import { CustomersTable } from "@/features/customers/customers-table";

const CustomersScreen = () => {
  return (
    <div className="p-4">
      <CustomersTable />
    </div>
  );
};

export default CustomersScreen;
